// extracted by mini-css-extract-plugin
export default {"container":"Popover_container__88UwN","popover":"Popover_popover__XJPM1","header":"Popover_header__Z8Ty-","body":"Popover_body__84Be-","footer":"Popover_footer__ix4ag"};